import React, { useState } from "react";
import { Link } from "react-router-dom";
const Tc = () => {

  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const messages = await getPrincipalMessage();
  //     setData(messages);
  //   };
  //   fetchData();
  // }, []);


  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
                     <li><Link to="/home"> Home</Link> </li>
          </li>
          <li> Information</li>
          <li> Transfer Certificate </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Transfer Certificate </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tcblock">
                <div className="tc">
                  <div>
                    <div className="formfil">
                      <div className="form-group">
                        <label for="number">
                          <p> Admission No. </p>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label for="number">
                          <p> Student Full Name </p>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="clr30"></div>
                    <input
                      type="button"
                      className="viewdetailsbtn"
                      value="Submit"
                    />
                  </div>
                </div>
                <iframe
                  src="/pdf/TC-Sample.pdf#toolbar=0"
                  width="100%"
                  height="500"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tc;
